// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const PinOffIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="PinOffIcon" ref={forwardedRef} {...props}>
      <path d="M15.005 2.5h-10v1.501H8.5V4h3v.001h3.504z" />
      <path d="M7.005 4.002H8.5V9.34a3.5 3.5 0 0 0-2 3.159h.75l-1.475 1.475A1 1 0 0 1 5.001 13v-.5a5 5 0 0 1 2.004-4z" />
      <path d="M9.25 14.743V17.5h.551a5 5 0 0 0 .4 0h.55V14H14a1 1 0 0 0 1-1v-.5a5 5 0 0 0-.8-2.708l-1.095 1.095A3.5 3.5 0 0 1 13.5 12.5h-2.008z" />
      <path d="m11.502 8.25 1.503-1.504V4.002h-1.503z" />
      <path d="M3.498 16.25 16.225 3.522l1.06 1.061L4.559 17.311z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const PinOffIcon = /* @__PURE__ */ Object.assign(PinOffIconComponent, {
  displayName: 'PinOffIcon',
});
